import { useEffect } from 'react';
import { useAppSelector as useSelector, useThunkDispatch as useDispatch } from 'hooks/reduxHooks';
import { setApprovalSettingsThunk } from 'store/approval/approval.thunk';
import { useFeatureFlag } from 'feature-flags';

export default function useApprovalSettings() {
  const { settings, isInitialized, isLoading, error } = useSelector((state) => state.approval);
  const dispatch = useDispatch();
  const isMakerCheckerEnabled = useFeatureFlag('tx_maker_checker');

  useEffect(() => {
    if (isInitialized || !isMakerCheckerEnabled) {
      return;
    }

    dispatch(setApprovalSettingsThunk());
  }, [dispatch, isInitialized, isMakerCheckerEnabled]);

  return { settings, isInitialized, isLoading, error };
}
